import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { useTranslations } from 'next-intl';

const RequestEquipmentServiceHeader = () => {
  const t = useTranslations();
  return (
    <div slot="header">
      <CatHeading variant="title-sm">{t('REQUEST_SERVICE')}</CatHeading>
    </div>
  );
};

export default RequestEquipmentServiceHeader;
